import axios from "axios";

const BASE = process.env.VUE_APP_API_BASE || "";

const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Low-level server/database errors that must never be shown to end users.
const TECHNICAL_ERROR = /SQLSTATE|Integrity constraint|Duplicate entry|Fatal error|Uncaught|Exception|Stack trace|syntax error|PDO|Call to (a member|undefined)/i;
const FRIENDLY_MESSAGE =
  "Something went wrong on our end. Please try again, or contact support if the problem continues.";

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes("/auth/login");
    if (error.response?.status === 401 && !isLoginRequest) {
      sessionStorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("token_expiry");
      localStorage.removeItem("user");
      localStorage.removeItem("org");
      window.location.replace("/login");
    }

    // Replace raw technical messages with a friendly one, keeping the original
    // in the console for developers.
    const data = error.response?.data;
    if (data && typeof data.message === "string" && TECHNICAL_ERROR.test(data.message)) {
      console.error(
        `API error [${error.response.status}] ${error.config?.method?.toUpperCase()} ${error.config?.url}:`,
        data.message,
      );
      data.message = FRIENDLY_MESSAGE;
    }

    return Promise.reject(error);
  },
);

export default api;
